import I18n from 'I18n';
import { useAuthorizeUberconference } from './hooks/useAuthorizeUberconference';
import { URLServiceComponent } from '../OAuthIntegrations/URLServiceComponent';
import { jsx as _jsx } from "react/jsx-runtime";
export const UberConferenceServiceComponent = ({
  metadata,
  onAuthCancelled,
  onAuthFailed,
  onAuthSucceeded,
  reconnectStarted,
  timeout,
  url
}) => {
  const {
    authorizeAccount
  } = useAuthorizeUberconference();
  const handleAuthSucceeded = code => {
    void authorizeAccount(code).then(() => {
      onAuthSucceeded === null || onAuthSucceeded === void 0 || onAuthSucceeded(code);
    }).catch(error => {
      onAuthFailed === null || onAuthFailed === void 0 || onAuthFailed({
        error,
        errorMessage: I18n.text('reconnect.errors.updateAccountFailed')
      });
    });
  };
  return /*#__PURE__*/_jsx(URLServiceComponent, {
    metadata: metadata,
    onAuthSucceeded: handleAuthSucceeded,
    onAuthCancelled: onAuthCancelled,
    onAuthFailed: onAuthFailed,
    reconnectStarted: reconnectStarted,
    timeout: timeout,
    url: url
  });
};